import { Provider } from '@angular/core';
import {
  JsxgraphService,
  JsxgraphThemeService,
  JsxgraphWidgetFactoryService,
  WIDGET_FACTORY,
  WidgetFactory,
} from '@examdojo/core/widget';
import { registerAllWidgets } from './registry';

/**
 * Provider for JSXGraph widget factory with automatic widget registration.
 * Use this in component/route providers.
 *
 * @example
 * ```ts
 * @Component({
 *   providers: [
 *     provideJsxgraphWidgets(),
 *     WidgetOrchestratorService,
 *   ]
 * })
 * ```
 */
export function provideJsxgraphWidgets(): Provider[] {
  return [
    JsxgraphService,
    JsxgraphThemeService,
    JsxgraphWidgetFactoryService,
    {
      provide: WIDGET_FACTORY,
      useFactory: (factory: JsxgraphWidgetFactoryService): WidgetFactory => {
        registerAllWidgets(factory);
        return factory;
      },
      deps: [JsxgraphWidgetFactoryService],
      multi: true,
    },
  ];
}
